// known issue https://github.com/date-fns/date-fns/issues/1677
import differenceInSeconds from 'date-fns/differenceInSeconds'
import format from 'date-fns/format'
import isThisWeek from 'date-fns/isThisWeek'
import isToday from 'date-fns/isToday'
import isYesterday from 'date-fns/isYesterday'
import { Map, OrderedMap, Range } from 'immutable'

import { normalizeMonth, normalizeYear } from './normalizations'

export const getDuration = (time: number, inMs = false, short = false) => {
  const ms = inMs ? time : time * 1000

  const hours = Math.round(ms / 1000 / 60 / 60)
  const minutes = Math.round(ms / 1000 / 60 - hours * 60)
  const seconds = Math.round((ms - (hours * 60 + minutes) * 60 * 1000) / 1000) || 1

  if (hours && hours > 1) return `${hours}\u200A${short ? 'h' : 'hours'}`
  if (hours) return `${hours}\u200A${short ? 'h' : 'hour'}`
  if (minutes) return `${minutes}\u200A${short ? 'm' : 'min'}`
  return `${seconds}\u200A${short ? 's' : 'sec'}`
}

export const getSecondsBetween = (start: Date | number | string | null, end?: Date | string | number, inMs = false) => {
  if (!start || !end) return 0
  const diffInSeconds = differenceInSeconds(new Date(end), new Date(start))
  return inMs ? diffInSeconds * 1000 : diffInSeconds
}

export const getRelativeTime = (date: Date | number) => {
  if (isToday(date)) return format(date, 'HH:mm')
  if (isYesterday(date)) return 'Yesterday'
  if (isThisWeek(date)) return format(date, 'dddd')
  return format(date, 'dd/MM/yyyy')
}

export const getDate = (date: Date | number) => format(date, 'dd/MM/yyyy')

export const MONTHS_MAP = OrderedMap({
  1: Map({ id: '1', loc: 'date.months.jan' }),
  2: Map({ id: '2', loc: 'date.months.feb' }),
  3: Map({ id: '3', loc: 'date.months.mar' }),
  4: Map({ id: '4', loc: 'date.months.apr' }),
  5: Map({ id: '5', loc: 'date.months.may' }),
  6: Map({ id: '6', loc: 'date.months.june' }),
  7: Map({ id: '7', loc: 'date.months.july' }),
  8: Map({ id: '8', loc: 'date.months.aug' }),
  9: Map({ id: '9', loc: 'date.months.sept' }),
  10: Map({ id: '10', loc: 'date.months.oct' }),
  11: Map({ id: '11', loc: 'date.months.nov' }),
  12: Map({ id: '12', loc: 'date.months.dec' }),
})

export const genYearsMap = (forwaredYears: number, start = new Date().getFullYear()) =>
  Range(start, start + forwaredYears).reduce(
    (acc, value) => acc.set(`${value}`, Map({ name: `${value}`, id: `${value}` })),
    OrderedMap(),
  )

export const extractCardDatePart =
  (shortDate: string, c = '/') =>
  (part: number) =>
    shortDate.split(c)[part]

export const prefixCardDatePart =
  (shortDate: string, prefix = '20') =>
  (part: number) =>
    `${part === 1 ? prefix : ''}${extractCardDatePart(shortDate)(part)}`

export const formatCardDate =
  (normYear = normalizeYear, normMonth = normalizeMonth) =>
  (year: string, month: string) =>
    `${normMonth(month)}/${normYear(year)}`

export const formatDateToDMY = (date: number | Date) => format(date, 'Do MMMM yyyy')
